// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    envName: 'dev',
    webEncryptKey: 'Bajajapi',
    webEncryptSecret: 'b@j@j@9#8#7#',
    appRunnerUrl: 'https://az2kkzwwer.ap-south-1.awsapprunner.com',
    smallCaseUrl: 'https://gatewayapi.smallcase.com',
    mfOnlineUrl: 'https://5noz27q6w1.execute-api.ap-south-1.amazonaws.com',
    // Retirement Readiness pages at /retirement (off in production until launch).
    retirement: true,
    // Retirement API on its own domain (API Gateway). Empty = /retirement/api, which `ng serve` proxies to the local app.
    retirementApi: '',

  };
  
  /*
   * For easier debugging in development mode, you can import the following file
   * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
   *
   * This import should be commented out in production mode because it will have a negative impact
   * on performance if an error is thrown.
   */
  // import 'zone.js/dist/zone-error';  // Included with Angular CLI.
  